<template>
	<div class="drawer">
		<el-drawer
		v-if="msg.card_number"
		size="711px"
		title="洗美卡详情"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding-bottom:40px;">
				<el-row class="row">
					<el-col :span="12">
						<span class="label">顾客：</span>
						<span class="value">{{msg.member_name}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">手机号：</span>
						<span class="value">{{msg.member_mobile}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">洗美卡名称：</span>
						<span class="value">{{msg.card_name}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">洗美卡编号：</span>
						<span class="value">{{msg.card_number}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">分类：</span>
						<span class="value">
							{{msg.card_category.name}}
						</span>
					</el-col>
					<el-col :span="12">
						<span class="label">适用宠物：</span>
						<span class="value">
							<span v-if="msg.apply_type===0">通用</span>
							<span v-if="msg.apply_type===1">猫</span>
							<span v-if="msg.apply_type===2">犬</span>
						</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">有效期至：</span>
						<span class="value">{{$public.FTime(msg.end_date,'YYYY-MM-DD HH:mm:ss')}}</span>
					</el-col>
					<el-col :span="12">
						<span class="label">适用体重：</span>
						<span class="value">
							{{
								msg.enable_weight_limit===1?
								msg.weight_min+'kg - '+msg.weight_max+'kg':'不限体重'
							}}
						</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">可用服务：</span>
						<span class="value">
							{{msg.service_name}}-{{msg.service_object_name}}
						</span>
					</el-col>
					<el-col :span="12">
						<span class="label">剩余/总次数：</span>
						<span class="value">{{msg.surplus_count}}/{{msg.total_count}}</span>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="12">
						<span class="label">使用周期限制：</span>
						<span class="value">
							<span v-if="msg.consume_type===1">不限</span>
							<span v-if="msg.consume_type===2">按年</span>
							<span v-if="msg.consume_type===3">按季度</span>
							<span v-if="msg.consume_type===4">按月</span>
							<span v-if="msg.consume_type===5">按周</span>
						</span>
					</el-col>
				</el-row>
			</div>
			<div style="font-size: 16px;color: #333;padding-left:20px;padding-bottom:12px;">使用记录</div>
			<el-table :data="msg.consume_record">
				<el-table-column label="编号" width="60">
					<template slot-scope="props">
						{{parseInt(props.$index+1)}}
					</template>
				</el-table-column>
				<el-table-column label="单号">
					<template slot-scope="props">
						<!-- <span class="biaoqianA" @click="toBingliSee(props.row.caseNumber)">{{props.row.caseNumber}}</span> -->
						{{props.row.order_num}}
					</template>
				</el-table-column>
				<el-table-column label="使用门店" width="100">
					<template slot-scope="props">
						<div>{{$public.getShopNameById(props.row.shop_id)}}</div>
					</template>
				</el-table-column>
				<el-table-column label="类型" width="100">
					<template slot-scope="props">
						<div v-if="props.row.consume_type===0">退款</div>
						<div v-if="props.row.consume_type===1">消费</div>
					</template>
				</el-table-column>
				<el-table-column label="使用时间" width="200">
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.consume_time,'YYYY-MM-DD HH:mm')}}</div>
					</template>
				</el-table-column>
			</el-table>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				msg:{},
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		props:{
			curItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
				this.msg = this.curItem;
				console.log(this.msg)
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.el-drawer__body{
				overflow: auto;padding:0 0 50px;
			}
			
		}
		.row{
			padding:14px 20px 14px;float: none;font-size: 20px;font-size: 12px;color:#666;border-bottom:1px solid #F2F2F2;
			.label{
				display: inline-block;width:90px;text-align: right;
			}
		}
	}
	
</style>
